import { createReducer, on } from "@ngrx/store";
import { ApuResourceActions } from "./apu-resource.actions";
import { initialApuResourceState, apuResourceAdapter } from "./apu-resource.state";

export const apuResourceReducer = createReducer(
    initialApuResourceState,
    on(ApuResourceActions.loadApuResourceSuccess, (state, action) => {
        return apuResourceAdapter.setAll(action.apuResources, {
            ...state,
            errorMessage: null
        });
    })
);